<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="订单编号" :value="2"></el-option>                            
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.buyFailedType" placeholder="请选择" size="small">
                        <el-option label="不限制定时购候补" :value="1"></el-option>
                        <el-option label="仅看定时购失败" :value="3"></el-option>
                        <el-option label="仅看候补失败" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.refundStatus" placeholder="请选择" size="small">
                        <el-option label="仅看待退款的" :value="1"></el-option>                        
                        <el-option label="仅看退款失败的" :value="4"></el-option>
                        <el-option label="仅看退款成功的" :value="3"></el-option>
                        <el-option label="不限制退款状态" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="退款时间" :value="2"></el-option>
                                <el-option label="取消时间" :value="3"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="time"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            :clearable="false"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                   <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                   <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="exportData" :loading="exportDataLoading">导出</el-button>           
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="refundStatus" label="退款状态" :width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.refundStatus == 0">无</span>
                        <span v-else-if="scope.row.refundStatus == 1">待退款</span>
                        <span v-else-if="scope.row.refundStatus == 2">退款中</span>
                        <span v-else-if="scope.row.refundStatus == 3" class="color-success">退款成功</span>
                        <span v-else-if="scope.row.refundStatus == 4" class="color-danger">退款失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderSn" label="订单编号" show-overflow-tooltip :min-width="150"></el-table-column>
                <el-table-column prop="typeView" label="退款类型" :min-width="100"></el-table-column>
                <el-table-column prop="payPlatformCodeName" label="支付平台" :min-width="130"><!-- 
                    <template slot-scope="scope">
                        <span v-if="scope.row.payPlatformCode == 1">支付宝</span>
                        <span v-else-if="scope.row.payPlatformCode == 2">微信</span>
                        <span v-else-if="scope.row.payPlatformCode == 3">财付通</span>
                        <span v-else-if="scope.row.payPlatformCode == 5">微信-抖音小程序</span>
                        <span v-else-if="scope.row.payPlatformCode == 6">支付宝-抖音小程序</span>
						<span v-else-if="scope.row.payPlatformCode == 7">云闪付</span>
						<span v-else-if="scope.row.payPlatformCode == 8">微信-小红书小程序</span>
						<span v-else-if="scope.row.payPlatformCode == 9">支付宝-小红书小程序</span>
						<span v-else-if="scope.row.payPlatformCode == 10">云闪付-支付宝</span>
						<span v-else-if="scope.row.payPlatformCode == 11">云闪付-微信</span>
                    </template> -->
                </el-table-column>
                <el-table-column label="订单实际收入" :min-width="140">
					<template slot-scope="scope">
						<p>票品金额：{{scope.row.incomeAmountFormat}}</p>
						<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
					</template>
				</el-table-column>
                <el-table-column label="退款金额">
                    <template slot-scope="scope">
                        <span v-if="scope.row.refundStatus == 1">{{scope.row.incomeAmountFormat}}</span>
                        <span v-else-if="scope.row.refundStatus == 3">{{scope.row.refundAmountFormat}}</span>
                    </template>
                </el-table-column>				           
                <el-table-column prop="cancelTime" label="取消时间" :min-width="150"></el-table-column>
        		<el-table-column prop="refundTime" label="退款成功时间" :min-width="150"></el-table-column>
                <el-table-column prop="activityId" label="演出ID" :min-width="100"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" show-overflow-tooltip :min-width="150"></el-table-column>
        		<el-table-column fixed="right" label="操作" :width="150">
        		    <template slot-scope="scope">				        
        		        <el-button
        		            v-if="scope.row.refundStatus === 4"
        		            type="text"
        		            size="small"
        		            @click="viewFailureReason(scope.row)"
        		            >查看失败原因</el-button>    
        		    </template>
        		</el-table-column>
                </el-table>
        </div>
		<div v-if="data" class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="getDataList"
		        :current-page.sync="params.pageNo"
		        :page-sizes="$pageSizes"
		        :page-size.sync="params.pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="data.totalCount || 0">
		    </el-pagination>
		</div>
        
    </div>
</template>

<script>

const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
    timeType: 3,
	refundStatus:-1,
	buyFailedType:1,
    timeType:3,
	timeBegin:'',
    timeEnd:'',
}

export default {
    components:{},
    data(){
        return{
            data: null,
            dataList: null,
            defaultEndTime: this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' ) + ' 23:59:59',
            defaultStartTime: this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 91), 'yyyy-MM-dd' ) + ' 00:00:00',
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                timeType: parseInt(this.$route.query.timeType || 3),
				refundStatus: parseInt(this.$route.query.refundStatus || -1), 
				buyFailedType: parseInt(this.$route.query.buyFailedType || 1),
                timeBegin:this.$route.query.startTime || '',
                timeEnd:this.$route.query.endTime || '',
            },
            listLoading: true,           
            time: [this.$route.query.startTime || '' , this.$route.query.endTime || ''],
			exportDataLoading:false,
			filter: null,
        }
    },
    computed:{
        
    },
    mounted() {
        this.time = [this.$route.query.startTime || this.defaultStartTime , this.$route.query.endTime || this.defaultEndTime]
        this.getDataList();
        
    },
    methods:{       
       
        //获取列表
        getDataList() {
            if( (!this.time || this.time.length < 1) && !this.params.searchValue ){
                this.$message.error('请选择查询时间段')
                return;
            }
			var k1 = new Date(this.time[1]).getTime() - new Date(this.time[0]).getTime();			
			var k2 = parseInt(k1/(1000*60*60*24) );			
			if( k2 > 100 ){
				this.$message.error('目前仅支持查询最多100天内的数据')
				return;
			}
			this.listLoading = true;
            this.params = {
                ...this.params,
                timeBegin:this.time && this.time[0] || '',
                timeEnd:this.time && this.time[1] || ''
            }
            this.$request({
                url: '/activity/refund/alt/list',
                method: "POST",
                data: this.params ,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                       this.data = result;
                       this.dataList = result.result || [];

                    } else {
                        this.data = null;
                        this.dataList = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
			this.time = [this.$route.query.startTime || this.defaultStartTime , this.$route.query.endTime || this.defaultEndTime]
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
				timeBegin:this.time && this.time[0] || '',
				timeEnd:this.time && this.time[1] || ''
            };
				
            this.getDataList();
        },
       // 查看失败原因
       viewFailureReason(row) {
           const {resultDesc} = row;
           const [reason = '', recommended = ''] = (resultDesc || '').split('<br>');
       
           const h = this.$createElement;
           const msg = [h('p', null, reason)];
       
           recommended && msg.push(h('p', null, recommended));
       
           this.$alert(h('div', null, msg), '退款失败原因', {
               confirmButtonText: '知道了',
               dangerouslyUseHTMLString: true,
               type: 'info',
               center: true
           });
       },
       // 导出
       async exportData() {       
           this.exportDataLoading = true;       
           const res = await this.$request({
               url:'/activity/refund/alt/batch/export',
               method: 'post',
               data: this.params ,
           }).catch(() => {
               return {data: {state: '0', msg: '请求错误'}};
           }).finally(() => {
               this.exportDataLoading = false;
           });
       
           const{state, msg} = res.data;
           
           if(state !== '1') {
               return this.$message.error(msg || '下载失败');
           }
           this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
               confirmButtonText: '立即查看',
               cancelButtonText: '稍后再看',
               type: 'success',
               center: true,
               closeOnClickModal: false
           }).then(() => {
               this.$router.push({path:'/workbench/downloadList'})
           }).catch(() => {})
       
           // downloadFileTmp(result.url, '演出退款.xlsx');
       }
       
       
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__row expanded{
    div{
        line-height: 30px;
    }
}
</style>